<ng-container>
  <ng-container>
    <app-table [columns]="headerTable" [dataSource]="dataSource" [hasButton]="true"
      [actionsTemplate]="actionsButtons"></app-table>
  </ng-container>


  <ng-template #actionsButtons let-uid="uid">
    <ng-container *ngIf="uid && (isEnabled(uid) !== undefined)">
      <ul class="custom-class">
        <li (click)="reconcile(uid)">
          <a>
            <mat-icon>account_balance</mat-icon>
            Conciliación bancaria
          </a>
        </li>

        <li *ngIf="!isEnabled(uid)" (click)="enableAutomaticRecurrent(uid)">
          <a>
            <mat-icon>autorenew</mat-icon>
            Activar Conciliación automática recurrente
          </a>
        </li>

        <li *ngIf="isEnabled(uid)" (click)="disableAutomaticRecurrent(uid)">
          <a>
            <mat-icon>block</mat-icon>
            Desactivar Conciliación automática recurrente
          </a>
        </li>
      </ul>
    </ng-container>
  </ng-template>
</ng-container>
